export default __webpack_public_path__ + "static/Wallop-SemiBold-5b004b48a46705ff9a29d0686237480f.woff2";